import { useEffect, useState } from "react";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { ObjectDinamicViewer } from "../../../../../contract/etapa-contrato/contrac/ublinvoice/FireElectronicDocument/ObjectDinamicViewer/ObjectDinamicViewer";

interface Props {
    exportMap: Function;
    procedure: any;
    pushProps?: Function;
    pushInfo?: Function;
}

interface Resp {
    Obs: string;
    Approve: string;
}

export const SACDP003 = ({ exportMap, pushInfo, pushProps }: Props) => {

    const [response, setResponse] = useState<Resp>({
        Approve: "",
        Obs: ""
    })

    const onExportMap = () => {
        if (pushProps) {
            pushProps(response)
        }
        if (pushInfo) {
            pushInfo(response.Obs)
        }
        exportMap(response)
    }

    const head = [
        { title: 'Validado', property: 'IsValid', visible: true },
        { title: 'Validado Por', property: 'ValidatorID', visible: true },
        { title: 'Código de Validación', property: 'ValidationResultCode', visible: true },
        { title: 'Fecha de Validación', property: 'ValidationDate', visible: true },
        { title: 'Descripción', property: 'ResponseDescription', visible: true },
        { title: 'Mensaje', property: 'StatusMessage', visible: true },
        { title: 'ZipFile', property: 'LinkURL', visible: true },
    ]

    useEffect(() => {
        if (response.Approve !== "") {
            onExportMap();
        }
    }, [response]);

    const updateForm = (app: boolean) => {
        setResponse(prev => ({ ...prev, Approve: `${app}` }));
    }

    return (
        <>
            <div className="row d-flex justify-content-between">
                <div className="col-md-12">
                    <ObjectDinamicViewer data={{}} head={head} />
                </div>
                <div className="col-md-12 mb-2">
                    <label>Observaciones</label>
                    <textarea className="form-control" value={response.Obs} onChange={(e) => { setResponse({ ...response, "Obs": e.target.value }) }} />
                </div>
                <div className="col-md-4">
                    <BasicButton icon="ri-checkbox-circle-line" eventClick={() => { updateForm(true) }} >Aprobar</BasicButton>
                </div>
                <div className="col-md-4">
                    <BasicButton icon="ri-close-circle-line" eventClick={() => { updateForm(false) }} >Rechazar</BasicButton>
                </div>
            </div>

        </>
    );
};